import {
  startLoading
} from '@/plugins/loading'
import http from '@/plugins/api'
import * as types from './types'

export default {
  /**
   * Get categories 1
   */
  async getCategories1({
    commit,
    dispatch
  }) {
    const r = await startLoading(dispatch, 'getCategories1', () =>
      http.get('videos/getCategories1')
    )
    commit(types.SET_FIRST_CATEGORIES, r.data)
    return r.data || []
  },
  /**
   * Get categories 2 based on passed in section 1
   * @param {string} category1 - Section 1 text
   */
  async getCategories2ByCategory1({
    commit,
    dispatch
  }, category1) {
    const r = await startLoading(dispatch, 'getCategories2ByCategory1', () =>
      http.get(`videos/getCategories2ByCategory1?category1=${encodeURIComponent(category1)}`)
    )

    commit(types.SET_SECOND_CATEGORIES, r.data)
    return r.data || []
  },
  /**
   * Create new category
   * @param {string} category
   */
  async createCategory({
    dispatch
  }, category) {
    const r = await startLoading(dispatch, 'createCategory', () =>
      http.post(`videos/createCategory`, category)
    )

    return r.data
  },
  /**
   * Delete new category
   * @param {number} categoryId
   */
  async deleteCategory({
    dispatch
  }, {
    id,
    isCategory1
  }) {
    const r = await startLoading(dispatch, 'deleteCategory', () =>
      http.post(`videos/deleteCategory?isCategory1=${isCategory1}`, {
        ID: id
      })
    )

    return r.data
  },
  /**
   * Reset categories2 value
   */
  resetCategories2({
    commit
  }) {
    commit(types.RESET_SECOND_CATEGORIES)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/category/actions.js